import { CommonModule } from '@angular/common';
import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { PalantirContentComponent } from '../content/content.component';
import { PalantirIconComponent } from '../icon/icon.component';
import type { PalantirIcon } from '../icon/icon.type';
import { PalantirTextComponent } from '../text/text.component';
import { expandCollapse } from './accordion.animation';

@Component({
  selector: 'palantir-accordion',
  standalone: true,
  imports: [CommonModule, PalantirContentComponent, PalantirTextComponent, PalantirIconComponent],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  animations: [expandCollapse],
})
export class PalantirAccordionComponent implements OnInit, OnChanges {
  /**
   * @deprecated Use the new header content projection instead.
   */
  @Input() public title?: string;

  @Input() public open?: boolean;

  @Input() public disabled?: boolean;

  @Input() public disabledText?: string;

  @Input() public disabledIcon?: PalantirIcon = 'info-outline';

  @Output() public onToggle = new EventEmitter<boolean>();

  public isOpen = signal(false);

  public ngOnInit(): void {
    if (this.open !== undefined) {
      this.isOpen.set(this.open);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      this.isOpen.set(changes['open'].currentValue);
    }
  }

  public toggleOpen(): void {
    this.isOpen.update((isOpen) => !isOpen);
    this.onToggle.emit(this.isOpen());
  }
}
